(function () {
  'use strict';

  if (window.bramoweKoszyk) return;
  window.bramoweKoszyk = true;

  var html = document.documentElement;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var hooks = [];

  var state = {
    opener: null,
    lastOutside: null,
    open: false,
    closeTimer: null,
    terms: false
  };

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function cssMs(el, name, fallback) {
    var v = getComputedStyle(el).getPropertyValue(name).trim();
    var n = parseFloat(v);
    if (isNaN(n)) return fallback;
    return /ms$/.test(v) ? n : n * 1000;
  }

  function getDrawer() {
    var el = document.getElementById('cart-drawer');
    return el && el.hasAttribute('data-bk-drawer') ? el : null;
  }

  function usable(el) {
    return !!el && el.isConnected && !el.disabled && el.getClientRects().length > 0 &&
      getComputedStyle(el).visibility !== 'hidden';
  }

  function announce(text) {
    var drawer = getDrawer();
    var live = drawer && drawer.querySelector('[data-bk-live]');
    text = (text || '').replace(/\s+/g, ' ').trim();
    if (!live || !text) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }

  
  function onOpenChange(drawer) {
    var open = drawer.hasAttribute('open');
    if (open === state.open) return;
    state.open = open;
    clearTimeout(state.closeTimer);

    if (open) {
      state.opener = state.lastOutside;
      html.classList.remove('bk-closing');
      html.classList.add('bk-open');
      afterRender(drawer, null, 'open');
      return;
    }

    html.classList.remove('bk-open');
    html.classList.add('bk-closing');
    var out = reducedMotion() ? cssMs(drawer, '--bk-dur-micro', 160) : cssMs(drawer, '--bk-dur-out', 240);
    state.closeTimer = setTimeout(function () {
      html.classList.remove('bk-closing');
      returnFocus(drawer);
    }, out + 80);
  }

  function returnFocus(drawer) {
    var active = document.activeElement;
    var opener = state.opener;
    if (drawer.hasAttribute('open') || !usable(opener) || active === opener) return;
    if (!active || active === document.body || drawer.contains(active)) opener.focus();
  }

  function rememberOutside(evt) {
    var drawer = getDrawer();
    var el = evt.target && evt.target.closest && evt.target.closest(FOCUSABLE);
    if (el && drawer && !drawer.contains(el)) state.lastOutside = el;
  }

  
  function focusables(drawer) {
    return [].filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
      return el.tabIndex >= 0 && usable(el) && !el.closest('[hidden]');
    });
  }

  function trapTab(evt) {
    if (evt.key !== 'Tab') return;
    var drawer = getDrawer();
    if (!drawer || !drawer.hasAttribute('open')) return;
    var list = focusables(drawer);
    if (!list.length) return;
    var i = list.indexOf(document.activeElement);
    var next;
    if (evt.shiftKey) next = i <= 0 ? list[list.length - 1] : list[i - 1];
    else next = i === -1 || i === list.length - 1 ? list[0] : list[i + 1];
    evt.preventDefault();
    evt.stopPropagation();
    next.focus();
  }


  
  function syncCount(drawer) {
    var body = drawer.querySelector('[data-bk-body]');
    var count = body ? parseInt(body.getAttribute('data-count'), 10) || 0 : 0;
    var pill = drawer.querySelector('[data-bk-count]');
    if (!pill) return;
    pill.hidden = count === 0;
    var num = pill.querySelector('[data-bk-count-num]');
    var text = pill.querySelector('[data-bk-count-text]');
    if (num) num.textContent = count;
    if (text) text.textContent = (text.getAttribute('data-template') || '').replace('[liczba]', count);
  }

  function lineSignatures(root) {
    var map = {};
    if (!root || !root.querySelectorAll) return map;
    var lines = root.matches && root.matches('.bk-line[data-key]') ? [root] : root.querySelectorAll('.bk-line[data-key]');
    [].forEach.call(lines, function (el) {
      var input = el.querySelector('.qty-input__input');
      var price = el.querySelector('.bk-line__price');
      map[el.getAttribute('data-key')] = (input ? input.getAttribute('value') : '') + '|' + (price ? price.textContent.replace(/\s+/g, '') : '');
    });
    return map;
  }

  function markFresh(drawer, records) {
    if (!records) return;
    var old = {};
    records.forEach(function (rec) {
      [].forEach.call(rec.removedNodes, function (node) {
        var sig = lineSignatures(node);
        Object.keys(sig).forEach(function (k) { old[k] = sig[k]; });
      });
    });
    if (!Object.keys(old).length) return;
    var now = lineSignatures(drawer);
    Object.keys(now).forEach(function (key) {
      if (old[key] === now[key]) return;
      var el = drawer.querySelector('.bk-line[data-key="' + key + '"]');
      if (!el) return;
      var target = old[key] === undefined ? el : el.querySelector('.bk-line__row');
      if (target) target.classList.add('bk-fresh');
    });
  }

  function restoreTerms(drawer) {
    var box = drawer.querySelector('[data-bk-terms-box]');
    if (box) box.checked = state.terms;
  }

  var scrollFrame = null;

  function measureScroll() {
    scrollFrame = null;
    var drawer = getDrawer();
    var box = drawer && drawer.querySelector('[data-bk-scroll]');
    if (!box) return;
    var foot = drawer.querySelector('[data-bk-foot]');
    var tall = !!foot && foot.offsetHeight > drawer.clientHeight * 0.4;
    drawer.classList.toggle('is-flow', tall);
    if (tall) {
      drawer.classList.remove('has-more');
      return;
    }
    var more = box.clientHeight > 0 && box.scrollHeight - box.scrollTop - box.clientHeight > 1;
    drawer.classList.toggle('has-more', more);
  }

  function scheduleScroll() {
    if (scrollFrame === null) scrollFrame = requestAnimationFrame(measureScroll);
  }

  var resizeObserver = window.ResizeObserver ? new ResizeObserver(function () { scheduleScroll(); }) : null;

  function afterRender(drawer, records, reason) {
    if (resizeObserver) {
      var foot = drawer.querySelector('[data-bk-foot]');
      if (foot && !foot.hasAttribute('data-bk-ro')) {
        foot.setAttribute('data-bk-ro', '');
        resizeObserver.observe(foot);
      }
    }
    syncCount(drawer);
    markFresh(drawer, records);
    restoreTerms(drawer);
    hooks.forEach(function (fn) { fn(drawer, records, reason); });
    scheduleScroll();
  }

  function isRegion(node) {
    return node.nodeType === 1 && (node.matches('cart-items, [data-bk-foot], [data-bk-drawer]'));
  }

  
  function collapse(line) {
    return new Promise(function (resolve) {
      if (reducedMotion()) {
        resolve();
        return;
      }
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        resolve();
      }
      line.style.height = line.offsetHeight + 'px';
      void line.offsetHeight;
      line.classList.add('is-leaving');
      line.style.height = '0px';
      line.addEventListener('transitionend', function (evt) {
        if (evt.target === line && evt.propertyName === 'height') finish();
      });
      setTimeout(finish, cssMs(line, '--bk-dur-out', 240) + 80);
    });
  }

  function removeLine(line, index) {
    var items = line.closest('cart-items');
    if (!items || typeof items.updateQuantity !== 'function' || line.classList.contains('is-leaving')) return false;
    collapse(line).then(function () {
      items.updateQuantity(String(index), 0, 'remove');
    });
    return true;
  }

  function onClickCapture(evt) {
    var drawer = getDrawer();
    if (!drawer || !drawer.contains(evt.target)) return;

    var busy = evt.target.closest('cart-items.pointer-events-none');
    if (busy && evt.target.closest('.js-remove-item, .qty-input__btn')) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }

    var remove = evt.target.closest('.js-remove-item');
    if (remove) {
      if (removeLine(remove.closest('.bk-line'), remove.getAttribute('data-index'))) {
        evt.preventDefault();
        evt.stopPropagation();
      }
      return;
    }

    var minus = evt.target.closest('.qty-input__btn[name="minus"]');
    if (minus) {
      var line = minus.closest('.bk-line');
      var input = line && line.querySelector('.qty-input__input');
      if (!input || parseInt(input.value, 10) > 1) return;
      if (removeLine(line, input.getAttribute('data-index'))) {
        evt.preventDefault();
        evt.stopPropagation();
      }
    }
  }

  
  function onSubmitCapture(evt) {
    var form = evt.target;
    if (!form || form.id !== 'cart-drawer-form') return;
    var drawer = getDrawer();
    if (!drawer || !drawer.contains(form)) return;
    var box = drawer.querySelector('[data-bk-terms-box]');
    if (!box || box.checked) return;
    evt.preventDefault();
    evt.stopPropagation();
    var wrap = box.closest('[data-bk-terms]');
    var msg = drawer.querySelector('[data-bk-terms-msg]');
    if (wrap) wrap.classList.add('is-error');
    box.setAttribute('aria-invalid', 'true');
    if (msg) msg.hidden = false;
    box.focus();
  }

  function onChange(evt) {
    var box = evt.target;
    if (!box.matches || !box.matches('[data-bk-terms-box]')) return;
    state.terms = box.checked;
    if (!box.checked) return;
    var wrap = box.closest('[data-bk-terms]');
    var msg = wrap && wrap.querySelector('[data-bk-terms-msg]');
    if (wrap) wrap.classList.remove('is-error');
    box.removeAttribute('aria-invalid');
    if (msg) msg.hidden = true;
  }

  
  var fs = { free: undefined, pct: 0, text: undefined };

  hooks.push(function updateShipping(drawer, records, reason) {
    var bar = drawer.querySelector('[data-bk-fs]');
    if (!bar) {
      fs.free = undefined;
      fs.pct = 0;
      fs.text = undefined;
      return;
    }
    var fill = bar.querySelector('[data-bk-fs-fill]');
    var free = bar.getAttribute('data-free') === 'true';
    var pct = parseInt(bar.getAttribute('data-pct'), 10) || 0;
    var known = fs.free !== undefined;
    var animate = known && reason === 'render' && !reducedMotion() && fs.pct !== pct;

    fill.style.setProperty('--bk-flow-phase', -(performance.now() % 2500) + 'ms');

    if (!animate) fill.style.width = pct + '%';

    if (animate) {
      bar.classList.add('is-instant');
      fill.style.width = fs.pct + '%';
      if (fs.free !== free) bar.classList.toggle('is-free', fs.free);
      void fill.offsetWidth;
      bar.classList.remove('is-instant');
      requestAnimationFrame(function () {
        fill.style.width = pct + '%';
        bar.classList.toggle('is-free', free);
      });
    }

    if (known && free && fs.free === false && !reducedMotion()) bar.classList.add('is-celebrating');

    var text = bar.querySelector('[data-bk-fs-text]');
    var said = text ? text.textContent.replace(/\s+/g, ' ').trim() : '';
    if (known && said !== fs.text && drawer.hasAttribute('open')) announce(said);

    fs.free = free;
    fs.pct = pct;
    fs.text = said;
  });

  
  function railArrows(drawer) {
    var track = drawer.querySelector('[data-bk-rail-track]');
    var prev = drawer.querySelector('[data-bk-rail-prev]');
    var next = drawer.querySelector('[data-bk-rail-next]');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= max - 1;
  }

  function railStep(drawer, dir) {
    var track = drawer.querySelector('[data-bk-rail-track]');
    var card = track && track.querySelector('.bk-acc');
    if (!card) return;
    var step = (card.getBoundingClientRect().width + 12) * 2;
    track.scrollBy({ left: dir * step, behavior: reducedMotion() ? 'auto' : 'smooth' });
  }

  function addFromRail(drawer, btn) {
    if (btn.disabled) return;
    var label = btn.querySelector('[data-bk-add-label]');
    var title = btn.getAttribute('data-title') || '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-bk-add')), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return r.json();
      })
      .then(function () {
        btn.classList.add('is-added');
        if (label) label.textContent = drawer.getAttribute('data-rail-added') || '';
        state.pendingAnnounce = (drawer.getAttribute('data-added-live') || '').replace('[produkt]', title);
        state.focusAfterAdd = title;
        setTimeout(function () { rerender(drawer); }, reducedMotion() ? 0 : 600);
      })
      .catch(function () {
        btn.disabled = false;
        announce(drawer.getAttribute('data-rail-error'));
      });
  }

  hooks.push(function rail(drawer) {
    var track = drawer.querySelector('[data-bk-rail-track]');
    if (track && !track.hasAttribute('data-bk-bound')) {
      track.setAttribute('data-bk-bound', '');
      track.addEventListener('scroll', function () { railArrows(drawer); }, { passive: true });
    }
    railArrows(drawer);

    if (state.pendingAnnounce) {
      announce(state.pendingAnnounce);
      state.pendingAnnounce = null;
    }

    if (state.focusAfterAdd && drawer.hasAttribute('open')) {
      var title = state.focusAfterAdd;
      state.focusAfterAdd = null;
      var links = drawer.querySelectorAll('.bk-line__title');
      for (var i = 0; i < links.length; i++) {
        if (links[i].textContent.replace(/[\u2011]/g, '-').replace(/\u2060/g, '').trim() === title.trim()) {
          links[i].focus({ preventScroll: true });
          break;
        }
      }
    }
  });

  function onRailClick(evt) {
    var drawer = getDrawer();
    if (!drawer || !drawer.contains(evt.target)) return;
    var add = evt.target.closest('[data-bk-add]');
    if (add) {
      evt.preventDefault();
      addFromRail(drawer, add);
      return;
    }
    if (evt.target.closest('[data-bk-rail-prev]')) railStep(drawer, -1);
    if (evt.target.closest('[data-bk-rail-next]')) railStep(drawer, 1);
  }

  
  hooks.push(function quotes(drawer, records, reason) {
    var list = drawer.querySelectorAll('[data-bk-quote]');
    if (list.length < 2) return;
    if (reason === 'open' || state.quote === undefined || state.quote >= list.length) {
      var next = state.quote;
      while (next === state.quote) next = Math.floor(Math.random() * list.length);
      state.quote = next;
    }
    [].forEach.call(list, function (q, i) { q.hidden = i !== state.quote; });
  });

  


  
  var CODE_MAX = 255;
  var extras = { code: false, codeValue: '' };

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function scroller(drawer) {
    return drawer.querySelector('[data-bk-scroll]');
  }

  function reveal(drawer, el, done) {
    var box = scroller(drawer);
    if (!box || !el) {
      if (done) done();
      return;
    }
    var view = box.getBoundingClientRect();
    var rect = el.getBoundingClientRect();
    var gap = 16;
    var delta = 0;
    if (rect.bottom + gap > view.bottom) delta = rect.bottom + gap - view.bottom;
    if (rect.top - delta < view.top + gap) delta = rect.top - view.top - gap;
    var target = Math.max(0, Math.min(box.scrollHeight - box.clientHeight, box.scrollTop + delta));
    if (Math.abs(target - box.scrollTop) < 1) {
      if (done) done();
      return;
    }
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      box.removeEventListener('scrollend', finish);
      if (done) done();
    }
    box.addEventListener('scrollend', finish);
    setTimeout(finish, reducedMotion() ? 0 : 600);
    box.scrollTo({ top: target, behavior: reducedMotion() ? 'auto' : 'smooth' });
  }

  function setPanel(drawer, kind, open) {
    var toggle = drawer.querySelector('[data-bk-toggle="' + kind + '"]');
    if (!toggle) return null;
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
    return panel;
  }

  function codeSay(drawer, text) {
    var box = drawer.querySelector('[data-bk-code]');
    if (!box) return;
    var msg = box.querySelector('[data-bk-code-msg]');
    var input = box.querySelector('[data-bk-code-input]');
    msg.textContent = text || '';
    msg.hidden = !text;
    if (text) {
      input.setAttribute('aria-invalid', 'true');
      reveal(drawer, box);
    } else {
      input.removeAttribute('aria-invalid');
    }
  }

  function postDiscount(codes) {
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) {
      if (!r.ok) throw new Error('discount ' + r.status);
      return r.json();
    });
  }

  function appliedCodes() {
    return fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.discount_codes || [])
          .filter(function (d) { return d.applicable; })
          .map(function (d) { return d.code; });
      });
  }

  function sameCode(a, b) {
    return a.toLowerCase() === b.toLowerCase();
  }

  function refreshDrawer() {
    var drawer = getDrawer();
    if (drawer) rerender(drawer, '[data-bk-toggle="code"]');
  }

  function applyCode(drawer) {
    var box = drawer.querySelector('[data-bk-code]');
    if (!box) return;
    var input = box.querySelector('[data-bk-code-input]');
    var apply = box.querySelector('[data-bk-code-apply]');
    var code = input.value.trim().slice(0, CODE_MAX);
    if (!code || apply.disabled) return;
    apply.disabled = true;
    box.classList.add('is-loading');
    codeSay(drawer, '');
    var kept;
    appliedCodes()
      .then(function (codes) {
        kept = codes.filter(function (c) { return !sameCode(c, code); });
        return postDiscount(kept.concat(code));
      })
      .then(function (cart) {
        var entry = (cart.discount_codes || []).filter(function (d) { return sameCode(d.code, code); })[0];
        if (entry && entry.applicable) {
          extras.code = false;
          extras.codeValue = '';
          refreshDrawer();
          return null;
        }
        extras.codeValue = code;
        codeSay(drawer, box.getAttribute('data-invalid'));
        return postDiscount(kept);
      })
      .catch(function () { codeSay(drawer, box.getAttribute('data-error')); })
      .then(function () {
        var b = drawer.querySelector('[data-bk-code]');
        if (!b) return;
        b.classList.remove('is-loading');
        b.querySelector('[data-bk-code-apply]').disabled = false;
      });
  }

  function removeCode(drawer, btn) {
    var code = btn.getAttribute('data-bk-code-remove');
    btn.disabled = true;
    appliedCodes()
      .then(function (codes) {
        return postDiscount(codes.filter(function (c) { return !sameCode(c, code); }));
      })
      .then(refreshDrawer)
      .catch(function () {
        btn.disabled = false;
        var box = drawer.querySelector('[data-bk-code]');
        if (box) codeSay(drawer, box.getAttribute('data-error'));
      });
  }

  function onExtrasClick(evt) {
    var drawer = getDrawer();
    if (!drawer || !drawer.contains(evt.target)) return;

    var toggle = evt.target.closest('[data-bk-toggle]');
    if (toggle) {
      var kind = toggle.getAttribute('data-bk-toggle');
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      extras[kind] = open;
      var panel = setPanel(drawer, kind, open);
      if (open && panel) {
        reveal(drawer, toggle.parentNode, function () {
          var field = panel.querySelector('input, textarea');
          if (field) field.focus({ preventScroll: true });
        });
      }
      return;
    }

    if (evt.target.closest('[data-bk-code-apply]')) {
      applyCode(drawer);
      return;
    }

    var remove = evt.target.closest('[data-bk-code-remove]');
    if (remove) removeCode(drawer, remove);
  }

  function onExtrasKey(evt) {
    if (evt.key !== 'Enter' || !evt.target.matches || !evt.target.matches('[data-bk-code-input]')) return;
    evt.preventDefault();
    applyCode(getDrawer());
  }

  function onExtrasInput(evt) {
    if (!evt.target.matches) return;
    if (evt.target.matches('[data-bk-code-input]')) {
      extras.codeValue = evt.target.value;
      codeSay(getDrawer(), '');
    }
  }

  hooks.push(function restoreExtras(drawer) {
    if (extras.code) setPanel(drawer, 'code', true);
    var input = drawer.querySelector('[data-bk-code-input]');
    if (input && extras.codeValue && !input.value) input.value = extras.codeValue;
  });

  
  var WARSAW = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Warsaw', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit'
  });
  var DAY = 86400000;
  var ftTimer = null;
  var SIM_KEY = 'bk-koszyk-czas';
  var DOW = { nd: 0, pn: 1, wt: 2, sr: 3, 'śr': 3, czw: 4, pt: 5, sob: 6 };
  var clock = { offset: 0, sim: undefined };

  function wallOf(ms) {
    var p = {};
    WARSAW.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
  }

  function parseSim(v) {
    var m = /^(?:(nd|pn|wt|sr|śr|czw|pt|sob)-)?(\d{1,2}):(\d{2})$/.exec((v || '').trim().toLowerCase());
    if (!m || +m[2] > 23 || +m[3] > 59) return null;
    var today = wallOf(Date.now() + clock.offset);
    today -= today % DAY;
    var day = today;
    if (m[1]) day = today + ((DOW[m[1]] - new Date(today).getUTCDay() + 7) % 7) * DAY;
    return { start: day + (+m[2] * 3600 + +m[3] * 60) * 1000, at: Date.now(), label: v.replace('-', ' ') };
  }

  function simulation(drawer) {
    if (clock.sim !== undefined) return clock.sim;
    clock.sim = null;
    if (drawer.getAttribute('data-test') !== 'true') return null;
    var param = new URLSearchParams(window.location.search).get('koszyk_czas');
    var stored = null;
    try {
      if (param === 'off') sessionStorage.removeItem(SIM_KEY);
      else if (param && parseSim(param)) sessionStorage.setItem(SIM_KEY, param);
      stored = sessionStorage.getItem(SIM_KEY);
    } catch (e) {
      stored = param && param !== 'off' ? param : null;
    }
    clock.sim = parseSim(stored);
    return clock.sim;
  }

  function warsawNow(drawer) {
    var sim = drawer && simulation(drawer);
    var w = sim ? sim.start + (Date.now() - sim.at) : wallOf(Date.now() + clock.offset);
    return { day: w - (w % DAY), sec: Math.floor((w % DAY) / 1000) };
  }

  function syncClock(drawer) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        var t = Date.parse(r.headers.get('Date') || '');
        if (!isNaN(t)) clock.offset = t - Date.now();
      })
      .catch(function () {})
      .then(function () { applyClock(drawer); });
  }

  function minutesOf(v) {
    var m = /^(\d{1,2}):(\d{2})$/.exec((v || '').trim());
    return m ? +m[1] * 60 + +m[2] : null;
  }

  function updateContact(drawer, now) {
    var box = drawer.querySelector('[data-bk-contact]');
    if (!box) return;
    var days = (box.getAttribute('data-days') || '').split(',').map(function (d) { return DOW[d.trim().toLowerCase()]; });
    var from = minutesOf(box.getAttribute('data-from'));
    var to = minutesOf(box.getAttribute('data-to'));
    var min = Math.floor(now.sec / 60);
    var day = days.indexOf(new Date(now.day).getUTCDay()) !== -1 && from !== null && to !== null && min >= from && min < to;
    [].forEach.call(box.querySelectorAll('[data-bk-contact-state]'), function (st) {
      var on = (st.getAttribute('data-bk-contact-state') === 'day') === day;
      st.toggleAttribute('data-off', !on);
      st.inert = !on;
      if (on) st.removeAttribute('inert'); else st.setAttribute('inert', '');
    });
    box.setAttribute('data-state', day ? 'day' : 'night');
    var chat = !!chatElement();
    [].forEach.call(box.querySelectorAll('[data-bk-chat]'), function (a) {
      var label = a.querySelector('[data-bk-chat-label]');
      if (label) label.textContent = chat ? a.getAttribute('data-ai-label') : a.getAttribute('data-fallback-label');
    });
  }

  function updateBadge(drawer) {
    var badge = drawer.querySelector('[data-bk-test-badge]');
    if (!badge) return;
    var sim = simulation(drawer);
    badge.hidden = !sim;
    if (sim) badge.textContent = (drawer.getAttribute('data-test-badge') || '').replace('[czas]', sim.label);
  }

  function applyClock(drawer) {
    updateBadge(drawer);
    updateContact(drawer, warsawNow(drawer));
    updateFulfillment(drawer);
  }

  function chatElement() {
    var list = document.querySelectorAll('shopify-chat, inbox-online-store-chat');
    for (var i = 0; i < list.length; i++) {
      if (typeof list[i].show === 'function') return list[i];
    }
    return null;
  }

  function onChatClick(evt) {
    var drawer = getDrawer();
    var trigger = evt.target.closest && evt.target.closest('[data-bk-chat]');
    if (!drawer || !trigger || !drawer.contains(trigger)) return;
    var chat = chatElement();
    if (!chat) return;
    evt.preventDefault();
    state.opener = null;
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
    var wait = (reducedMotion() ? cssMs(drawer, '--bk-dur-micro', 160) : cssMs(drawer, '--bk-dur-out', 240)) + 200;
    setTimeout(function () { chat.show(); }, wait);
  }

  function isoDay(ms) {
    return new Date(ms).toISOString().slice(0, 10);
  }

  function isWorkday(ms, holidays) {
    var dow = new Date(ms).getUTCDay();
    return dow !== 0 && dow !== 6 && holidays.indexOf(isoDay(ms)) === -1;
  }

  function nextWorkday(ms, holidays) {
    var d = ms + DAY;
    while (!isWorkday(d, holidays)) d += DAY;
    return d;
  }

  function dayText(ms, today, el) {
    var d = new Date(ms);
    var m = d.getUTCMonth() + 1;
    var date = d.getUTCDate() + '.' + (m < 10 ? '0' + m : m);
    if (ms - today === DAY) return (el.getAttribute('data-tomorrow') || '').replace('[data]', date);
    var names = (el.getAttribute('data-weekdays') || '').split(',');
    return (names[d.getUTCDay()] || '').trim() + ' ' + date;
  }

  function fulfillmentText(el) {
    var holidays = (el.getAttribute('data-holidays') || '').split(/[\s,]+/);
    var cutoff = (parseInt(el.getAttribute('data-cutoff'), 10) || 12) * 3600;
    var now = warsawNow(getDrawer());
    var left = cutoff - now.sec;
    if (isWorkday(now.day, holidays) && left > 0) {
      var mins = Math.ceil(left / 60);
      var h = Math.floor(mins / 60);
      var fmt = el.getAttribute('data-time') || '';
      if (mins % 60 === 0) fmt = fmt.replace(/\s*\[m\][^[]*$/, '');
      var czas = h > 0
        ? fmt.replace('[g]', h).replace('[m]', mins % 60)
        : (el.getAttribute('data-time-short') || '').replace('[m]', mins);
      return {
        text: (el.getAttribute('data-before') || '').replace('[czas]', czas).replace('[dzień]', dayText(nextWorkday(now.day, holidays), now.day, el)),
        wait: (60 - (now.sec % 60)) * 1000 + 50
      };
    }
    var ship = nextWorkday(now.day, holidays);
    return {
      text: (el.getAttribute('data-after') || '').replace('[dzień]', dayText(nextWorkday(ship, holidays), now.day, el)),
      wait: (60 - (now.sec % 60)) * 1000 + 50
    };
  }

  function updateFulfillment(drawer) {
    clearTimeout(ftTimer);
    var el = drawer.querySelector('[data-bk-ft]');
    if (!el) return;
    var out = fulfillmentText(el);
    var target = el.querySelector('[data-bk-ft-text]');
    if (target && target.textContent !== out.text) target.textContent = out.text;
    if (drawer.hasAttribute('open')) ftTimer = setTimeout(function () { updateFulfillment(drawer); }, out.wait);
  }

  hooks.push(function clockHook(drawer, records, reason) {
    applyClock(drawer);
    if (reason === 'open') syncClock(drawer);
  });

  function sectionId(drawer) {
    var wrap = drawer.closest('.shopify-section');
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }

  function fetchSections(id, tries) {
    return fetch('?sections=' + id + ',cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections && sections[id]) return sections;
        if (tries > 0) {
          return new Promise(function (res) { setTimeout(res, 500); }).then(function () { return fetchSections(id, tries - 1); });
        }
        return null;
      });
  }

  function rerender(drawer, focusSel) {
    var id = sectionId(drawer);
    if (!id || typeof drawer.renderContents !== 'function') {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      return Promise.resolve();
    }
    return fetchSections(id, 3)
      .then(function (sections) {
        if (!sections) return;
        var scroll = drawer.querySelector('[data-bk-scroll]');
        var top = scroll ? scroll.scrollTop : 0;
        return drawer.renderContents({ sections: sections }, false).then(function () {
          var box = drawer.querySelector('[data-bk-scroll]');
          if (box) box.scrollTop = top;
          var el = focusSel && drawer.querySelector(focusSel);
          if (el) el.focus({ preventScroll: true });
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sections['cart-icon-bubble']) {
            var tmp = document.createElement('div');
            tmp.innerHTML = sections['cart-icon-bubble'];
            var inner = tmp.querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }
        });
      })
      .catch(function () {});
  }

  function onRefreshCapture(evt) {
    var drawer = getDrawer();
    var items = drawer && drawer.querySelector('cart-items');
    if (!items || items.getAttribute('data-empty') !== 'true' || typeof drawer.renderContents !== 'function') return;
    evt.stopImmediatePropagation();
    var id = sectionId(drawer);
    if (!id) return;
    fetchSections(id, 1)
      .then(function (sections) {
        if (!sections) return;
        drawer.renderContents({ sections: sections }, false);
      })
      .catch(function () {});
  }

  
  function bind(drawer) {
    if (drawer.hasAttribute('data-bk-ready')) return;
    drawer.setAttribute('data-bk-ready', '');

    new MutationObserver(function () { onOpenChange(drawer); })
      .observe(drawer, { attributes: true, attributeFilter: ['open'] });

    new MutationObserver(function (records) {
      var relevant = records.filter(function (rec) { return isRegion(rec.target); });
      if (relevant.length) afterRender(drawer, relevant, 'render');
    }).observe(drawer, { childList: true, subtree: true });

    drawer.addEventListener('click', onClickCapture, true);
    drawer.addEventListener('click', onRailClick);
    drawer.addEventListener('click', onChatClick);
    drawer.addEventListener('click', onExtrasClick);
    drawer.addEventListener('keydown', onExtrasKey);
    drawer.addEventListener('input', onExtrasInput);
    drawer.addEventListener('change', onChange);
    drawer.addEventListener('scroll', scheduleScroll, true);
    window.addEventListener('resize', scheduleScroll);

    state.open = drawer.hasAttribute('open');
    if (resizeObserver) resizeObserver.observe(drawer);
    afterRender(drawer, null, 'init');
  }

  function init() {
    var drawer = getDrawer();
    if (drawer) bind(drawer);
  }

  document.addEventListener('focusin', rememberOutside);
  document.addEventListener('click', rememberOutside, true);
  document.addEventListener('keydown', trapTab, true);
  document.addEventListener('submit', onSubmitCapture, true);
  document.addEventListener('dispatch:cart-drawer:refresh', onRefreshCapture, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    Promise.resolve().then(init);
  }
  document.addEventListener('shopify:section:load', init);
})();
